import { spEsri } from '../../globals'

export default {
  methods: {
    getWidgetGraphicsLayer (name) {
      return spEsri.graphicsLayers[name?.toLowerCase() || this.$options.name.toLowerCase()]
    },
    getGraphicFromWidgetGraphicsLayer (fid, name) {
      return spEsri.graphicsLayers[name?.toLowerCase() || this.$options.name.toLowerCase()].graphics.find((graphic) => graphic.uid === fid)
    },
    getGraphicFromWidgetGraphicsLayerWithUidAndId (fid, id, name) {
      return spEsri.graphicsLayers[name?.toLowerCase() || this.$options.name.toLowerCase()].graphics.find((graphic) => graphic.uid === fid && graphic.layer.id === id)
    },
    getAllGraphicsFromWidgetGraphicsLayer (name) {
      return spEsri.graphicsLayers[name?.toLowerCase() || this.$options.name.toLowerCase()].graphics
    },
    clearWidgetGraphicsLayer (name) {
      if (spEsri.graphicsLayers[name?.toLowerCase() || this.$options.name.toLowerCase()]) {
        spEsri.graphicsLayers[name?.toLowerCase() || this.$options.name.toLowerCase()].removeAll()
      }
    },
    clearGraphicsFromWidgetGraphicsLayerWithUidAndId (fid, id, name) {
      if (spEsri.graphicsLayers[name?.toLowerCase() || this.$options.name.toLowerCase()]) {
        const graphicToRemove = this.getGraphicFromWidgetGraphicsLayerWithUidAndId(fid, id, name)
        spEsri.graphicsLayers[name?.toLowerCase() || this.$options.name.toLowerCase()].removeMany([graphicToRemove])
      }
    },
    clearGraphicsFromWidgetGraphicsLayer (fid, name) {
      if (spEsri.graphicsLayers[name?.toLowerCase() || this.$options.name.toLowerCase()]) {
        const graphicToRemove = this.getGraphicFromWidgetGraphicsLayer(fid, name)
        spEsri.graphicsLayers[name?.toLowerCase() || this.$options.name.toLowerCase()].removeMany([graphicToRemove])
      }
    },
    clearAllWidgetsGraphicsLayers () {
      for (const key in spEsri.graphicsLayers) {
        spEsri.graphicsLayers[key].removeAll()
      }
    },
    isCurrentWidgetGraphicsLayerVisible () {
      return spEsri.graphicsLayers[this.$options.name.toLowerCase()].visible
    },
    showWidgetGraphicsLayer (name) {
      spEsri.graphicsLayers[name?.toLowerCase() || this.$options.name.toLowerCase()].visible = true
    },
    hideWidgetGraphicsLayer (name) {
      spEsri.graphicsLayers[name?.toLowerCase() || this.$options.name.toLowerCase()].visible = false
    },
    addGraphicsToWidgetGraphicsLayer (graphics, name) {
      spEsri.graphicsLayers[name?.toLowerCase() || this.$options.name.toLowerCase()].addMany(graphics)
    },
    async highlightSceneFeatures (features, sceneLayer) {
      const highlightedSceneFeatures = []
      try {
        const layerView = await spEsri.sceneView.whenLayerView(sceneLayer)
        for (const feature of features) {
          let highlight = layerView.highlight(feature.objectid)
          if (sceneLayer.type === 'building-scene') {
            highlight = layerView.highlight(feature.graphic)
          }
          highlightedSceneFeatures.push(highlight)
        }
        spEsri.highlightedSceneFeatures[this.$options.name.toLowerCase()] = highlightedSceneFeatures
      } catch (error) {
        console.error(error)
      }
    },
    clearHighlightedSceneFeatures () {
      if (spEsri.highlightedSceneFeatures[this.$options.name.toLowerCase()]) {
        for (const higlightedFeature of spEsri.highlightedSceneFeatures[this.$options.name.toLowerCase()]) {
          higlightedFeature.remove()
        }
        spEsri.highlightedSceneFeatures[this.$options.name.toLowerCase()] = []
      }
    },
    clearHighlightedSceneFeaturesFromWidget (name) {
      if (spEsri.highlightedSceneFeatures[name]) {
        for (const higlightedFeature of spEsri.highlightedSceneFeatures[name]) {
          higlightedFeature.remove()
        }
        spEsri.highlightedSceneFeatures[name] = []
      }
    },
    clearAllHighlightedSceneFeatures () {
      for (const key in spEsri.highlightedSceneFeatures) {
        for (const higlightedFeature of spEsri.highlightedSceneFeatures[key]) {
          higlightedFeature.remove()
        }
        spEsri.highlightedSceneFeatures[key] = []
      }
    },
    convertHexaToRgba (highlightColor) {
      const hexaToR = parseInt(highlightColor.substring(1, 3), 16)
      const hexaToG = parseInt(highlightColor.substring(3, 5), 16)
      const hexaToB = parseInt(highlightColor.substring(5, 7), 16)
      const hexaToA = parseInt(highlightColor.substring(7, 9), 16) / 255
      const rgba = { r: hexaToR, g: hexaToG, b: hexaToB, a: hexaToA }

      return rgba
    },
  },
}
